<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ruZ2K4/tc-custom/9781609251543.jpg?1736884955046" alt="This image is the cover for the book Let Go and Live in the Now"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Let Go and Live in the Now
      </h1>
      <p class="bookDescription body article font2">
        <b>“If you want to have more happiness, joy, and fulfillment in your life, read this book and dance in the streets.”—Michael Toms, author of <i>A Time for Choices</i></b><br/>  <br/> That chronic, nagging sense of discontent, that sneaky feeling that something is missing from life, that secret yearning for “something more” can all be healed. In <i>Let Go and Live in the Now</i>, bestselling author Guy Finley brings the great Wisdom Teachings of centuries past into our lives in an intimate, accessible way. Each chapter tackles a hurt that keeps us from experiencing inner peace and happiness and includes a brief essay and a contemporary teaching story followed by exercises to help readers incorporate the teaching into everyday life. Each chapter ends with “Ask the Masters,” a question-and-answer format with such historical and modern-day spiritual masters as Buddha, St. Augustine, G.I. Gurdjieff, Henry David Thoreau, Peter Matthiessen, and Jeanne Guyon.<br/>  <br/> “It only seems as though there’s something more important for you to do than just quietly be yourself,” writes Guy Finley. Imagined heavens never last, but eternal principles empower readers to live in “the now.” From the first story of Katie, her broken heart, and the doctor who shows her how to heal it to the very last lesson of Paul who relocates himself from the city to the country and still can’t see “the forest for the trees,” readers see themselves in these eloquent retellings of ancient spiritual principles.<br/>  <br/> “There is something profoundly healing in the way Guy Finley talks to us, as if he understands what we have gone through and what we are now capable of.”—Hugh Prather, author of <i>Notes to Myself</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Guy Finley
      </h2>
      
      <p class="authorDescription body article">Guy Finley is a spiritual teacher who distills the wisdom of the ages and makes it accessible to all. His bestselling books include The Essential Laws of Fearless Living, The Intimate Enemy, and Design Your Own Destiny. He appears regularly on the Jordan Rich radio show and has appeared on Larry King Live, CNN, Entertainment Tonight, and many other radio and TV shows.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Red Wheel
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01a98847